import { useMemo, useState } from "react";
import DraggableDataTable from "../components/DraggableDataTable";
import { useUserProvider } from "../providers/UserProvider";
import { UpdateCategory } from "../services/api/category";
import { useLoaderProvider } from "../providers/LoaderProvider";

const LinkedContentList = ({
  categoryId,
  linkedContent,
  resetList
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { user } = useUserProvider();
  const { doSetShowLoadingModal } = useLoaderProvider();

  const metadata = useMemo(() => {
    return [
      {
        name: 'key',
        label: 'Key',
        parser: (data) => (data.id),
      },
      {
        name: 'name',
        label: 'Title',
        parser: (data) => (data.name || data.title || ""),
      },
      {
        name: 'topics',
        label: 'Topics/Listings',
        parser: (data) => data?.topics?.join(', '),
        width: 300,
      },
      {
        name: 'categories',
        label: 'Categories',
        parser: (data) => data?.categories?.filter?.((category) => category.active === true)?.map((category) => category.name).join(', '),
        width: 300,
      },
      {
        name: "release_date",
        label: "Release Date",
        parser: (data) => data?.release_date,
      },
      {
        name: 'tags',
        label: 'Tags',
        parser: (data) => <span className="ttnk-tag">{data?.tags?.join(', ')}</span>,
        width: 300,
      },
      {
        name: 'active',
        label: 'Active',
        parser: (data) => data?.active === true ? "Yes" : "No",
      },
    ]
  }, [])

  const onOrderChange = async (reorderedData) => {
    try {
      doSetShowLoadingModal(true);

      const payload = {
        linked_content: reorderedData
      }
  
      await UpdateCategory(categoryId, user.idToken, { data: payload })
        .then(() => {
          setTimeout(() => {
            doSetShowLoadingModal(false)
          }, [500])
        })
    } catch (error) {
      console.error({ error })
      doSetShowLoadingModal(false)
    }
  }

  return (
    <div className="bg-white px-12 p-5 mt-5 ttnk-table-container">
      <div className="grid grid-flow-col grid-cols-2 gap-4 mt-5 mb-1">
        <h1 className="ttnk-page__title m-0">Linked Contents</h1>
      </div>
      <DraggableDataTable
        metadata={metadata}
        dataLoader={resetList}
        contentType='linkedContentList'
        data={linkedContent}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        searchKeys={['name']}
        removeContainerStyle={true}
        onOrderChange={onOrderChange}
      />
    </div>
  )
}

export default LinkedContentList;
